import { useCallback, useState } from 'react';
import { loadPreferences, savePreferences, type Preferences } from '@/storage/prefs';

/** Preferences are tiny and synchronous — no need for a store or context. */
export function usePreferences() {
  const [prefs, setPrefs] = useState<Preferences>(() => loadPreferences());

  const update = useCallback((patch: Partial<Preferences>) => {
    setPrefs(savePreferences(patch));
  }, []);

  return { prefs, update };
}
